import { createContext } from 'react';
import { TooltipUses } from '../utils/types';

export const defaultPopoverContext: { use: TooltipUses } = {
  use: 'default',
};

export const PopoverContext = createContext(defaultPopoverContext);

export const { Consumer, Provider } = PopoverContext;
